import type { RutaCobrosQuery } from '@aid/shared';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  data: () => [...dashboardKeys.all, 'data'] as const,
  planVsRealYear: (year: string) => [...dashboardKeys.all, 'plan-vs-real-year', year] as const,
  facturacionPorDia: (dia: number) => [...dashboardKeys.all, 'facturacion-por-dia', dia] as const,
  rutaCobros: (filters: RutaCobrosQuery) => [...dashboardKeys.all, 'ruta-cobros', filters] as const,
};
